export {
  default,
} from 'web-ssr/app/common/components/SharingMetaTags/SharingMetaTags';
export {
  buildServiceSharingDescription,
  buildSharingUrl,
} from 'web-ssr/app/common/components/SharingMetaTags/utils';
